// How much of a goal's order is already secured (Backlog #27, 2026-10-23).
// Mirrors the backend's app/utils/goal_progress.py: every accepted lead fills a slot of
// the order, whether DemandArc Accepted, Approved Pending Call Review or Client Accepted.
// The Goals page used to divide DemandArc Accepted alone by the quantity, so a goal that
// had been delivered and client-accepted read 0% complete.

// Prefer the server's own `accepted_count`; fall back to summing the three buckets for a
// goal object that predates it (or was patched locally).
export function acceptedCount(g) {
  if (!g) return 0;
  if (g.accepted_count != null) return g.accepted_count;
  return (g.da_accepted_count || 0) + (g.approved_pending_call_review_count || 0) + (g.client_accepted_count || 0);
}

export function neededCount(g) {
  const qty = (g && g.quantity_ordered) || 0;
  return qty ? Math.max(0, qty - acceptedCount(g)) : null;
}

// Whole-number percent of the order accepted (may exceed 100 for an over-delivered goal),
// or null when the goal has no quantity or counts were not loaded.
export function percentComplete(g) {
  const qty = (g && g.quantity_ordered) || 0;
  const loaded = g && (g.accepted_count != null || g.da_accepted_count != null || g.client_accepted_count != null);
  if (!qty || !loaded) return null;
  return Math.round((acceptedCount(g) / qty) * 100);
}
